/* eslint-disable max-len */
import React from "react";

export function FilterIcon({
  height,
  width,
  viewBox = "0 0 20 20",
  svgColor,
}: CustomSVGProp) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox || "0 0 20 20"}
    >
      <path
        d="M7.4984 14.9997C7.49833 15.1545 7.54141 15.3064 7.6228 15.4381C7.7042 15.5698 7.8207 15.6763 7.95923 15.7455L9.6259 16.5788C9.75298 16.6423 9.89418 16.6723 10.0361 16.6659C10.178 16.6594 10.3159 16.6168 10.4368 16.5421C10.5576 16.4674 10.6573 16.363 10.7264 16.2389C10.7955 16.1148 10.8318 15.9751 10.8317 15.833V9.99967C10.8319 9.58666 10.9855 9.18843 11.2626 8.88217L17.2817 2.22467C17.3896 2.10514 17.4606 1.95691 17.486 1.79791C17.5114 1.63891 17.4902 1.47595 17.425 1.32874C17.3598 1.18152 17.2533 1.05636 17.1184 0.968384C16.9835 0.880408 16.8261 0.833388 16.6651 0.833008H1.66506C1.5039 0.833066 1.34622 0.879854 1.21111 0.967705C1.07599 1.05556 0.969255 1.1807 0.903818 1.32798C0.838381 1.47525 0.817053 1.63835 0.842418 1.7975C0.867783 1.95665 0.938753 2.10503 1.04673 2.22467L7.06756 8.88217C7.34468 9.18843 7.49821 9.58666 7.4984 9.99967V14.9997Z"
        fill="none"
        stroke={svgColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default FilterIcon;
